module.exports = __webpack_public_path__ + "img/approved-budget-sm.e071212c.svg";